
import { NgDirectiveFilterStrategy } from "./strategy/NgDirectiveFilterStrategy";
import { CustomDirectiveFilterStrategy } from "./strategy/CustomDirectiveFilterStrategy";
import { HtmlTabFilterStrategy } from "./strategy/HtmlTabFilterStrategy";
import { IFormItemDirectiveScope } from "./IFormItemDirectiveScope";
import { FormItemTemplateConfig } from "./form-item-template-config";
import { TemplateType } from './enum/FormItemTemplateType';
import { CommonTool } from "../../modules/common/tool/common-tool";

/**
 * 
 * @param eventBusService 
 * @returns 
 * 
 * directive规则:
 *  1.ng指令:ng-model="" ng-minlength="" ng-maxlength="" ng-pattern=""
 *  2.自定义指令:qpv-
 *  3.html属性: max-length required
 */
export function FormItemDirective(eventBus: qpmn.common.tool.IEventBus, $compile: angular.ICompileService): ng.IDirective {
    return {
        require: ["^formItem"],
        controllerAs: "$ctrl",
        controller: ["$scope", function ($scope) {
            let ctrl = this;
        }],
        replace: false,
        transclude: {
            "header": "?formItemHeader",
            "content": "?formItemContent",
            "title": "?formItemTitle",
            "message": "?formItemMessage"
        },
        template: function (tElement: JQLite, tAttrs: angular.IAttributes) {
            // 获取默认模板
            let contentTemplate = require("./template/form-item-content.template.html");

            // 指令获取策略
            // TODO 使用factory创建策略 
            let ngDirectiveFilterStrategy = new NgDirectiveFilterStrategy();
            let customDirectiveFilterStrategy = new CustomDirectiveFilterStrategy();
            let htmlTabFilterStrategy = new HtmlTabFilterStrategy();

            // 匹配的指令
            let validateDirective: string = "";

            /**
            * @description 选取获取指令策略，将匹配的指令添加到字符串中，拿到由所有匹配指令组成的字符串
            * @param attributes 
            * @returns directive{string}
            */
            let catchValidateDirective = (attributes: angular.IAttributes, attrItem: string): string => {
                let directive = "";

                let strategy;
                // 选取获取策略
                if (ngDirectiveFilterStrategy.isMatcher(attrItem)) {
                    // 判断是否为ng指令
                    strategy = ngDirectiveFilterStrategy;
                } else if (customDirectiveFilterStrategy.isMatcher(attrItem)) {
                    // 判断是否为自定义指令
                    strategy = customDirectiveFilterStrategy;
                } else if (htmlTabFilterStrategy.isMatcher(attrItem)) {
                    // 判断是否为html属性
                    strategy = htmlTabFilterStrategy;
                }

                if (strategy) {
                    directive = strategy.getDirective(attributes.$attr[attrItem], attributes[attrItem]);
                }
                return directive;
            }

            /**
             * @description 将验证通过的directive添加至item内容上
             * @param directive 
             * @param template 
             * @returns 
             */
            let setValidateDirective = (directive: string, template: string): string => {
                let reg = new RegExp('/\w/' + '=["][^"]*["]|' + '/\w/' + "=['][^']*[']|" + '/\w/');
                //將每個需要添加的指令或html元素等单独取出來
                let directiveArray: any[] = directive.split(reg);

                //判断是否存在相同指令，存在则替换，不存在则直接加进去
                for (let i: number = 0, len: number = directiveArray.length; i < len; i++) {
                    //名称
                    let directiveName: string = directiveArray[i].split('=')[0];
                    let nameReg = new RegExp(directiveName + '[^-\w]');
                    //不存在相同内容，增加内容
                    if (template.search(nameReg) == -1) {
                        // 找到input标签中的'>',在他前面将directiveArray[i]添加进去
                        let snippet: string = template.substring(0, template.indexOf('>'));
                        template = snippet + ' ' + directiveArray[i] + '>';
                    } else if (template.search(nameReg) != -1) {
                        //存在相同内容，替换原来的内容
                        let contentReg = new RegExp(directiveName + '=["][^"]*["]|' + directiveName + "=['][^']*[']|" + directiveName);
                        template = template.replace(contentReg, directiveArray[i]);
                    }
                }
                return template;
            }

            /**
             * @description 创建formItemContainer模板
             * @return {*}  {string}
             */
            let createFormItemContainerTpl = (): string => {

                // 根据name和type获取到匹配的formItem HTML
                let formItemMatchedHTML = CommonTool.findTemplateByTypeAndName(FormItemTemplateConfig, TemplateType.CONTAINER, "formItem");
                let formItemHTML = formItemMatchedHTML && formItemMatchedHTML.length == 1 ? formItemMatchedHTML[0] : "";

                return formItemHTML;
            }

            /**
             * @description 将使用了${xxx}占位符的地方替换成给定模板
             * @returns template{string}
             */
            let replaceTemplateContent = (contentTemplate: string): string => {
                // 获取formItemContainer模板HTML
                let formItemHTML = createFormItemContainerTpl();
                // 将占位符替换成formItemContent模板
                return CommonTool.stringReplaceContent(formItemHTML, contentTemplate, "content");
            }

            Object.keys(tAttrs).filter((tAttrsKey, tAttrsIdx) => tAttrsIdx > 1).map(attrItem => {
                // 抓取attribute上设置的指令或标签
                validateDirective = catchValidateDirective(tAttrs, attrItem);

                // 将每一项标签或指令设置至默认模板中的输入框中
                if (validateDirective) {
                    contentTemplate = setValidateDirective(validateDirective, contentTemplate.default);
                }
            })

            // 替换模板内容
            let templateContent = replaceTemplateContent(contentTemplate);

            // 替换header
            templateContent = templateContent.replace("$header", "{{" + tAttrs.header + "}}");

            return templateContent
        },
        link: (scope: IFormItemDirectiveScope) => {
            scope.isShow = true;
        }
    }
}

FormItemDirective.$inject = ["eventBus", "$compile"];